module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1200-5ecc13ca5faae3d69fa99ea07ea674ef.jpg";